module.exports = require('./words.json')
